import { Box,Tab,Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { trackEventMatomo } from "../../helpers/matomo";
import UserSearch from "./ListaUsuarios";
import TagControll from "./TagControll";
import UserRegister from "./UserRegister";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function UsersTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tabs = ['consulta de usuários', 'cadastro de usuário', 'controle de tags'];
    setValue(newValue);
    trackEventMatomo('gestão de usuários', 'click', 'aba', tabs[newValue]);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          textColor="secondary"
          indicatorColor="secondary"
          value={value}
          onChange={handleChange}>
          <Tab label={t('users.userSearch.title')} value={0} />
          <Tab label={t('users.userRegister.title')} value={1} />
          <Tab label={t('users.tagControll.title')} value={2} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <UserSearch />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UserRegister />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <TagControll />
      </CustomTabPanel>
    </>
  );
}
